import { useTranslation } from "react-i18next";

import TableRow from "@mui/material/TableRow";
import TableCell from "@mui/material/TableCell";
import Link from "@mui/material/Link";
import EditIcon from "@mui/icons-material/Edit";
import DeleteForeverIcon from "@mui/icons-material/DeleteForever";

import { StyledSwitch } from "../../components/Base";
import Button from "../../components/Button";
import { formatValidPeriod } from "../../services/formatters";
import courseCategoryService from "../../services/courseCategory";

const CustomCourseItem = ({ onEdit, onDelete, onStatusChange, course }) => {
  const { t } = useTranslation();
  return (
    <TableRow>
      <TableCell>{course.id}</TableCell>
      <TableCell>{course.name}</TableCell>
      <TableCell>{formatValidPeriod(course.validPeriod, t)}</TableCell>
      <TableCell>{courseCategoryService.getByCode(course.courseCategory)?.getDisplayName(t)}</TableCell>
      <TableCell>
        <StyledSwitch
          title={t("custom_courses.change_status")}
          checked={course.status === "active"}
          onChange={() => onStatusChange(course.id, course.status === "active" ? "passive" : "active")}
        />
      </TableCell>
      <TableCell>
        <Link style={{ marginRight: "1rem" }} onClick={() => onEdit(course.id)}>
          <Button title={t("custom_courses.edit_action")} icon={<EditIcon />} />
        </Link>
        <Link onClick={() => onDelete(course.id)}>
          <Button title={t("custom_courses.delete_action")} icon={<DeleteForeverIcon color="error" />} />
        </Link>
      </TableCell>
    </TableRow>
  );
};

export default CustomCourseItem;
